import convert from "convert-units";
import _ from "lodash";
import find from "lodash/find";
import getLoadash from "lodash/get";
import moment from "moment";
import React from "react";
import { withTranslation } from "react-i18next";
import submit from "submit-form";
import { DATE_FORMATS, PARAMETER_OPTIONS } from "../../../../constants";
import { RillContext } from "../../../../rill/RillReact/share/base";
import addMetadata from "../../../../utils/add-metadata";
import { hasAssistantParameterValue } from "../../../../utils/exercise-validations";
import { buildSupersets } from "../../../../utils/prefix-calculator";
import { getUserToRequest } from "../../../dashboard/settings/manage-coaches/utils/manage-coaches-utils";
import DayEditor from "./EditMode/DayEditor";
import DayNormal from "./NormalMode/DayNormal";
import i18n from "../../../../i18n";
import { joinRpeForEdit, splitRpeText } from "../../../../utils/rpe-range";

const { FREEFORM } = PARAMETER_OPTIONS;

const { DATE_YEAR_FORMAT, DATE_DAY_FORMAT } = DATE_FORMATS;

const insertAtIndex = (arr, index, item) => [
  ...arr.slice(0, index),
  item,
  ...arr.slice(index),
];

class MonthDay extends React.Component {
  constructor(props, context) {
    super(props, context);
    const { date, scheduledSessions, daysInEditMode } = props;
    this.dayString = date.clone().format(DATE_DAY_FORMAT);
    this.state = {
      movements: {},
      editDayMode: false,
      openOptions: false,
      showOptions: false,
      showAddExercise: false,
      selectedExercise: null,
      tempExercises: [],
      exercises: scheduledSessions[this.dayString] || [],
      newExercise: [],
      daysInEditMode,
      viewportWidth: null,
    };
    this.handleInput = this.handleInput.bind(this);
    this.handleEditTemporalInput = this.handleEditTemporalInput.bind(this);
    this.editSet = this.editSet.bind(this);
    this.removeSet = this.removeSet.bind(this);
    this.addTempSet = this.addTempSet.bind(this);
    this.getTempExercise = this.getTempExercise.bind(this);
    this.saveEditedExercise = this.saveEditedExercise.bind(this);
    this.handleSuperset = this.handleSuperset.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.resetExercises = this.resetExercises.bind(this);
    this.toggleEditDayMode = this.toggleEditDayMode.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
    this.removeTempExercise = this.removeTempExercise.bind(this);
    this.removeTempSet = this.removeTempSet.bind(this);
  }

  updateDimensions() {
    this.setState((prevState) => ({
      ...prevState,
      viewportWidth: window.innerWidth,
    }));
  }

  componentDidMount() {
    !this.state.viewportWidth &&
      this.setState((prevState) => ({
        ...prevState,
        viewportWidth: window.innerWidth,
      }));

    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  displayError(error = "") {
    submit(`/actions/refresh/?`, {
      method: "GET",
      body: {
        error: typeof error === "string" ? error : error?.message || "",
      },
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { date, daysInEditMode } = nextProps;
    const dayString = date.clone().format(DATE_DAY_FORMAT);

    const next = nextProps.scheduledSessions[dayString] || [];
    if (
      next.length !== this.state.exercises.length ||
      this.props.scheduledSessions[dayString] !== next
    ) {
      this.setState({ exercises: next });
    }

    if (daysInEditMode !== this.props.daysInEditMode) {
      this.setState({
        daysInEditMode: daysInEditMode,
        ...(!daysInEditMode.length && { editDayMode: false }),
      });
    }
  }

  resetExercises() {
    this.setState({
      editDayMode: false,
      tempExercises: [],
      exercises: this.props.scheduledSessions[this.dayString] || [],
    });
    this.props.handleEditDate({
      type: "remove",
      day: this.dayString,
    });
  }

  editSet(props) {
    const { newValue, otherNew, exerciseId, setIdx } = props;
    const { tempExercises } = this.state;
    const { field, value } = newValue;
    const tempExercisesModified = tempExercises.map((exercise) => {
      if (exercise._id === exerciseId) {
        const sets = exercise.sets.map((set, idy) => {
          if (parseInt(idy, 10) === parseInt(setIdx, 10)) {
            // Searching for the set to edit
            const setModified = {
              [field]: value,
              ...(otherNew && otherNew.value !== "NaN"
                ? { [otherNew.field]: otherNew.value }
                : {}),
            };
            return { ...set, ...setModified };
          }
          return set;
        });
        return { ...exercise, sets };
      }
      return exercise;
    });
    this.setState({
      tempExercises: tempExercisesModified,
    });
  }

  handleInput(props) {
    const {
      value,
      field,
      onlyNumber = false,
      exerciseId,
      setIdx = false,
      otherNew = false,
    } = props;
    // setIdx = is a combination between exerciseId and setIdx+
    if (
      (onlyNumber && Number.isNaN(value)) ||
      (field === "reps" &&
        value &&
        !value.includes("-") &&
        Number.isNaN(value)) ||
      (field === "sets" && Number.isNaN(value))
    )
      return this.displayError(
        this.props.t("calendar.monthDay.errors.onlyNumbers")
      );

    if (!setIdx && setIdx !== 0) {
      const exerciseModified = this.state.tempExercises.map((exercise) => {
        if (exercise._id === exerciseId) {
          exercise[field] = value;
        }
        return exercise;
      });
      this.setState({
        exercises: exerciseModified,
        tempExercises: exerciseModified,
      });
      return;
    }

    const finalIdx =
      typeof setIdx === "string" && setIdx.length
        ? setIdx.split("-")[1]
        : setIdx;

    const editSetParams = {
      newValue: {
        field: field,
        value: onlyNumber ? parseFloat(value) : value,
      },
      exerciseId,
      setIdx: finalIdx,
      otherNew,
    };

    this.editSet(editSetParams);
  }

  handleEditTemporalInput(props) {
    const { field, value, exerciseId } = props;
    const { newExercise } = this.state;
    const exercisesModified = newExercise.map((_exercise) => {
      if (exerciseId === _exercise._id) {
        _exercise[field] = value;
      }
      return _exercise;
    });

    this.setState({
      newExercise: exercisesModified,
    });
  }

  handleSelectChange(value, exerciseId) {
    if (!value) return;
    const { movement, newPrimary, repMaximum } = value;
    const { units } = this.context.locals.activeUser;

    const exercisesModified = this.state.tempExercises.map((exercise) => {
      if (exercise._id === exerciseId) {
        addMetadata(
          exercise,
          movement,
          newPrimary,
          this.context.locals.activeUserToRequest.primaryExercises,
          this.context.locals.activeUserToRequest.exerciseLibrary
        );

        if (value.newPrimary && value.newPrimary !== "assistant") {
          //if the selection is secondary
          exercise.primary = value.newPrimary;
          exercise.secondary = value.movement;
          exercise.secondaryRepMaximum = value.repMaximum;
          exercise.type = "secondary";
          exercise.parameters = "null";
        } else if (value.newPrimary && value.newPrimary === "assistant") {
          //if the selection is assistant
          exercise.primary = value.newPrimary;
          exercise.secondary = value.movement;
          exercise.secondaryRepMaximum = 0;
          exercise.type = "assistant";
          if (value.parameters) exercise.parameters = value.parameters;
        } else {
          //if the section is primary
          exercise.primary = value.movement;
          exercise.secondary = "null";
          exercise.type = "primary";
          exercise.secondaryRepMaximum = 0;
          exercise.parameters = "null";
        }
        exercise.sets.forEach((set) => {
          const newLoadValue = _.round(
            (repMaximum * set.percentRepMax) / 100,
            2
          ); //we are calculating the new value of the load property

          //if we have to convert it to lb
          if (units === "imperial") {
            set.load = _.round(convert(newLoadValue).from("kg").to("lb"), 2);
          }

          set.load = newLoadValue; //adding the new value of load property
        });
      }
      return exercise;
    });

    this.setState({
      exercises: exercisesModified,
      tempExercises: exercisesModified,
    });
  }

  removeSet(exerciseId, setIdx) {
    const actualExercises = this.state.tempExercises;
    const result = actualExercises.find((ex) => ex._id === exerciseId);
    // if this is the last set of the exercise, remove the whole execise
    if (result.sets.length === 1) {
      if (result.complex && result.exercises) {
        submit("/actions/complex/remove", {
          method: "POST",
          body: {
            exercises: result.exercises,
          },
        });
      } else {
        submit(`/actions/exercise/remove/${result._id}`, {
          method: "GET",
          body: {
            proxyAthlete: this.context.locals.athlete._id,
          },
        });
      }
    } else {
      const exercisesWithSetRemoved = actualExercises.map((exercise) => {
        if (
          exercise._id === exerciseId ||
          (result?.complex &&
            result?.complex === exercise.complex &&
            result?.complexInstance === exercise.complexInstance)
        ) {
          return {
            ...exercise,
            sets: exercise.sets.filter((_set, idx) => {
              return parseInt(idx, 10) !== parseInt(setIdx, 10);
            }),
          };
        }
        return exercise;
      });
      this.setState({
        tempExercises: exercisesWithSetRemoved,
      });
    }
  }

  removeTempSet(exerciseId, setIdx) {
    const actualExercises = this.state.tempExercises;
    const result = actualExercises.find((ex) => ex._id === exerciseId);
    const exercisesWithSetRemoved = actualExercises.map((exercise) => {
      if (
        exercise._id === exerciseId ||
        (result?.complex &&
          result?.complex === exercise.complex &&
          result?.complexInstance === exercise.complexInstance)
      ) {
        return {
          ...exercise,
          sets: exercise.sets.filter((_set, idx) => {
            return parseInt(idx, 10) !== parseInt(setIdx, 10);
          }),
        };
      }
      return exercise;
    });
    this.setState({ tempExercises: exercisesWithSetRemoved });
  }

  saveEditedExercise(athleteId) {
    try {
      const exerciseWithoutTemp = this.state.tempExercises.map(
        (tempExercise) => {
          const { type, parameters, sets, primary, secondary } = tempExercise;

          let firstComplexExercise;
          if (
            tempExercise.complex &&
            tempExercise.complexInstance &&
            tempExercise.indexInComplex !== 0
          ) {
            firstComplexExercise = this.state.tempExercises.find((ex) => {
              return (
                ex.complex === tempExercise.complex &&
                ex.complexInstance === tempExercise.complexInstance &&
                ex.indexInComplex === 0
              );
            });
          }

          const setsModified = sets.map((editedSet, idx) => {
            // Work on a copy: a blocked save must leave the cells as typed.
            const set = { ...editedSet };
            if (set.temp) delete set.temp;

            const isRepRange = set.reps && String(set.reps).includes("-");
            if (isRepRange) {
              if (!set.reps.match(/^\d{1,4}-?\d{1,4}$/)) {
                throw new Error(
                  this.props.t("calendar.monthDay.errors.repsRangeInvalid")
                );
              }
              const [repsLower, reps] = set.reps.split("-");
              set.reps = reps || repsLower;
              if (reps) {
                set.repsLower = repsLower;
              }
            }
            if (!isRepRange && set.repsLower) set.repsLower = null;

            // if the exercise is part of a complex, get the values from the first exercise (the one beind edited in the UI)
            // reps do have their own inputs
            if (firstComplexExercise) {
              set.sets = firstComplexExercise.sets?.[idx]?.sets || set.sets;
              set.rpe = firstComplexExercise.sets?.[idx]?.rpe || set.rpe;
              set.rpeLower = firstComplexExercise.sets?.[idx]?.rpe
                ? firstComplexExercise.sets[idx].rpeLower
                : set.rpeLower;
              set.load = firstComplexExercise.sets?.[idx]?.load || set.load;
              set.loadDrop =
                firstComplexExercise.sets?.[idx]?.loadDrop || set.loadDrop;
            }

            const rpeError = splitRpeText(set);
            if (rpeError) throw new Error(i18n.t(`common:${rpeError}`));

            if (type !== "assistant") {
              const findChain = (field) => {
                const result = set[field]
                  ? set[field] === 0 ||
                    set[field] === "0" ||
                    set[field] === undefined ||
                    set[field] === "" ||
                    set[field] === null
                  : true;
                return result;
              };

              const resultChain = {
                reps: findChain("reps"),
                sets: findChain("sets"),
                rpe: findChain("rpe"),
                load: findChain("load"),
                loadDrop: findChain("loadDrop"),
              };

              const isAmrap = set.rpe === "AMRAP";

              const errorFound =
                (resultChain.reps && !isAmrap) || resultChain.sets;

              if (errorFound)
                throw new Error(
                  this.props.t("calendar.monthDay.errors.repsSetsRequired")
                );
            } else if (
              parameters &&
              !parameters.includes(FREEFORM) &&
              !hasAssistantParameterValue(set, parameters)
            ) {
              const setsOrRounds = parameters.includes("Sets")
                ? "sets"
                : parameters.includes("Rounds")
                  ? "rounds"
                  : false;
              if (setsOrRounds) set[setsOrRounds] = 1;
              else
                throw new Error(
                  this.props.t("calendar.monthDay.errors.parametersRequired")
                );
            }
            return set;
          });

          let movementLibrary = {};
          if (secondary) {
            const libraryCoach = _.get(
              this.context.locals.activeUser,
              `exerciseLibrary.${primary}`,
              []
            );

            const existsCoach = _.find(libraryCoach, {
              movement: secondary,
            });

            if (existsCoach) {
              existsCoach.primary = primary;
              movementLibrary = existsCoach;
            }
          }

          if (tempExercise._tempoChecked && !tempExercise.tempo?.trim()) {
            throw new Error("Please enter the tempo value");
          }
          delete tempExercise._tempoChecked;

          if (tempExercise.notes === "") {
            tempExercise.notes = " ";
          }
          delete tempExercise.order;

          return {
            ...tempExercise,
            sets: setsModified,
            movementLibrary,
          };
        }
      );
      submit(
        `/actions/exercise/quick-edit?proxyAthlete=${athleteId}&reqSource=calendar`,
        {
          method: "POST",
          body: { exercises: exerciseWithoutTemp },
        }
      );
      this.setState({
        editDayMode: false,
        tempExercises: exerciseWithoutTemp,
      });
      this.props.handleEditDate({
        type: "remove",
        day: this.dayString,
      });
    } catch (err) {
      return this.displayError(err?.message ?? err);
    }
  }

  addTempSet(props) {
    const { exerciseId, pos = false, freeForm = false } = props;
    const exercises = [...this.state.tempExercises];
    const result = exercises.find((_ex) => _ex._id === exerciseId);
    const finalPos = pos
      ? parseInt(pos, 10) + 1
      : result
        ? result.sets.length
        : -1;
    const tempExercises = exercises.map((tempExercise) => {
      if (
        tempExercise._id === exerciseId ||
        (result?.complex &&
          result?.complex === tempExercise.complex &&
          result?.complexInstance === tempExercise.complexInstance)
      ) {
        const objectToInsert = freeForm
          ? {
              percentRepMax: 0,
              equipped: false,
              zone: "deload",
              freeform: "",
              temp: true,
            }
          : result.primary !== "assistant"
            ? {
                load: "",
                sets: "",
                reps: "",
                rpe: "",
                percentRepMax: "",
                equipped: false,
                zone: "deload",
                temp: true,
              }
            : {
                distance: "",
                temp: true,
              };
        const sets = insertAtIndex(tempExercise.sets, finalPos, objectToInsert);
        return { ...tempExercise, sets };
      }
      return tempExercise;
    });

    this.setState({
      tempExercises,
    });
  }

  getTempExercise(exerciseId, _tempIdx = null) {
    const tempIdx = _tempIdx ? _tempIdx.split("-")[1] : null;
    return (
      this.state.newExercise.find((newExercise) => {
        return (
          (tempIdx && tempIdx === "new" && newExercise._id === exerciseId) ||
          (!tempIdx && newExercise._id === exerciseId)
        );
      }) || false
    );
  }

  handleSuperset(mode = "add", { fullExercise, nextExerciseId }) {
    if (mode === "remove") {
      this.setState({
        tempExercises: this.state.tempExercises.map((elem) => {
          if (fullExercise._id === elem._id) delete elem.nextSuperset;
          return elem;
        }),
      });
    }
    submit(`/actions/exercise/superset/${mode}`, {
      method: "POST",
      body: {
        exercise: fullExercise._id,
        nextExercise: nextExerciseId,
        fullExercise,
        monthCalendar: true,
      },
    });
  }

  toggleEditDayMode() {
    const { editDayMode, exercises } = this.state;
    if (!editDayMode) {
      const tempExercises = _.cloneDeep(exercises).map((exercise) => {
        exercise.sets.forEach((set) => {
          if (set.reps && set.repsLower) {
            set.reps = `${set.repsLower}-${set.reps}`;
          }
          joinRpeForEdit(set);
        });
        return exercise;
      });
      this.setState({
        editDayMode: true,
        tempExercises,
      });
      this.props.handleEditDate({ type: "add", day: this.dayString });
    }
  }

  removeTempExercise(id, sameList, fromExercises) {
    // Exercise is being moved to a different day, remove from tempExercises
    if (!sameList) {
      this.setState((prevState) => ({
        tempExercises: prevState.tempExercises.filter((ex) => ex._id !== id),
      }));
    } else {
      // Exercise moved within the same day, reorder tempExercises
      this.setState((prevState) => ({
        tempExercises: fromExercises
          .map((id) => prevState.tempExercises.find((ex) => ex._id === id))
          .filter(Boolean),
      }));
    }
  }

  render() {
    const {
      date,
      handleSelectDate,
      selectedDates,
      handleRemoveMultiple,
      expanded,
      editCalendar,
      removing,
    } = this.props;

    const {
      activeUser,
      activeUserToRequest,
      organizationOwner,
      query,
      withWeight,
      fromMetric,
      athlete,
      cycles,
      femaleCycleLogs,
      femaleCycleSettings,
    } = this.context.locals;
    const userToMeasure = getUserToRequest(activeUser, organizationOwner);

    const { exercises } = this.state;
    const intensityMeasure =
      _.get(activeUserToRequest, "intensityMeasure", "rpe") === "rpe"
        ? "RPE"
        : "RiR";
    const isRiR = intensityMeasure === "RiR";
    const isInActiveMonth =
      date.clone().month() === moment(query.month, DATE_YEAR_FORMAT).month();
    const dayString = date.clone().format(DATE_DAY_FORMAT);
    const isToday = dayString === moment().format(DATE_DAY_FORMAT);
    const isPast = date.clone().isBefore(moment(), "day");
    const cycleDetail = getLoadash(find(exercises, "cycle"), "cycle", {});
    const cycle = find(
      cycles,
      (cyc) => String(cyc._id) === String(cycleDetail.id)
    );
    const supersets = buildSupersets(exercises);
    const sections = this.context.locals.scheduledSections?.[dayString] || [];
    const program = cycle
      ? find(cycle.programs, (prog) => prog.order === cycleDetail.program)
      : {};
    const units = activeUser.units;
    const round = userToMeasure.round;

    const handleState = (newValue) => {
      this.setState(newValue);
    };

    return editCalendar ? (
      <DayEditor
        {...Object.assign(
          {},
          {
            setState: handleState,
            supersets,
            sections,
            editSection: query.editSection,
            athleteId: athlete._id,
            removeSet: this.removeSet,
            repMaximums: this.context.locals.athlete.repMaximums,
            handleSelectChange: this.handleSelectChange,
            getTempExercise: this.getTempExercise,
            handleInput: this.handleInput,
            addTempSet: this.addTempSet,
            removeTempSet: this.removeTempSet,
            toggleEditDayMode: this.toggleEditDayMode,
            resetExercises: this.resetExercises,
            saveEditedExercise: this.saveEditedExercise,
            handleSuperset: this.handleSuperset,
            handleEditTemporalInput: this.handleEditTemporalInput,
            dayString,
            fromMetric,
            withWeight,
            intensityMeasure,
            isRiR,
            opacity:
              this.state.daysInEditMode.length &&
              !this.state.daysInEditMode.includes(this.dayString),
            removeTempExercise: this.removeTempExercise,
          },
          this.state,
          this.props,
          this.context.locals
        )}
      />
    ) : (
      <DayNormal
        {...{
          isInActiveMonth,
          isPast,
          isToday,
          expanded,
          exercises,
          dayString,
          date,
          handleSelectDate,
          selectedDates,
          handleRemoveMultiple,
          supersets,
          sections,
          withWeight,
          fromMetric,
          units,
          round,
          program,
          intensityMeasure,
          isRiR,
          mobile: this.state.viewportWidth && this.state.viewportWidth <= 640,
          removing,
          athlete,
          query,
          femaleCycleLogs,
          femaleCycleSettings,
        }}
      />
    );
  }
}

MonthDay.contextType = RillContext;

export default withTranslation(["athlete-portal", "common"])(MonthDay);
